import { memo } from "react";
import { DialogContent } from "@mui/material";

import RegisterSuccessForm from "components/auth/RegisterSuccessForm";
import ClosableDialog from "components/shared/ClosableDialog";
import useDialog from "hooks/useDialog";

const RegisterSuccessDialog: React.FC = () => {
  const { openRegisterSuccessDialog, setOpenRegisterSuccessDialog } =
    useDialog();

  return (
    <ClosableDialog
      open={openRegisterSuccessDialog}
      onClose={() => setOpenRegisterSuccessDialog(false)}
    >
      <DialogContent>
        <RegisterSuccessForm />
      </DialogContent>
    </ClosableDialog>
  );
};

export default memo(RegisterSuccessDialog);
